export const categories = [
  {
    slug: 'shishang-chuanda',
    name: '时尚穿搭',
    description: '探索适合成熟女性的穿搭风格，从职场着装到休闲搭配，展现独特的熟女时尚品味。',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20in%20stylish%20neutral%20tone%20outfit%2C%20sophisticated%20fashion%20photography%2C%20soft%20warm%20lighting%2C%20minimalist%20cream%20background%2C%20high%20fashion%20editorial%20style%2C%20confident%20pose%2C%20luxurious%20fabric%20texture%2C%20timeless%20elegance%2C%20clean%20composition&width=800&height=600&seq=cat-fashion-01&orientation=landscape',
  },
  {
    slug: 'hufu-baoyang',
    name: '护肤保养',
    description: '针对30岁以上女性的专业护肤方案，涵盖抗衰老、日常护理与季节性保养的全面指南。',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20skincare%20products%20arranged%20on%20a%20marble%20surface%20with%20soft%20natural%20light%2C%20minimalist%20beauty%20photography%2C%20warm%20cream%20and%20rose%20tones%2C%20luxurious%20serum%20bottles%2C%20fresh%20botanical%20elements%2C%20sophisticated%20aesthetic%2C%20clean%20composition&width=800&height=600&seq=cat-skincare-02&orientation=landscape',
  },
  {
    slug: 'shenghuo-meixue',
    name: '生活美学',
    description: '分享熟女的生活智慧，从家居布置到品质生活，打造属于自己的优雅生活方式。',
    icon: 'ri-home-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Warm%20and%20elegant%20living%20room%20interior%20with%20soft%20neutral%20tones%2C%20fresh%20flowers%20in%20a%20ceramic%20vase%2C%20aesthetic%20home%20decor%2C%20natural%20light%20streaming%20through%20sheer%20curtains%2C%20cozy%20sophisticated%20atmosphere%2C%20minimalist%20design%2C%20warm%20beige%20and%20cream%20palette&width=800&height=600&seq=cat-lifestyle-03&orientation=landscape',
  },
  {
    slug: 'ziwo-chengzhang',
    name: '自我成长',
    description: '关注熟女的内心世界，从情绪管理到职业发展，助力每位成熟女性活出更精彩的人生。',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20reading%20a%20book%20by%20a%20sunlit%20window%2C%20peaceful%20contemplative%20moment%2C%20warm%20natural%20light%2C%20sophisticated%20atmosphere%2C%20cream%20and%20beige%20interior%2C%20serene%20expression%2C%20lifestyle%20photography%2C%20soft%20focus%20background&width=800&height=600&seq=cat-growth-04&orientation=landscape',
  },
];

export const articles = [
  {
    id: 1,
    slug: '30sui-nvxing-chunqiu-zhibo-dapei',
    title: '30岁女性的春秋职场穿搭指南：知性与优雅的完美平衡',
    excerpt: '如何在职场中通过穿搭展现成熟魅力？本文从面料选择、配色方案到整体造型，为你解析熟女职场穿搭的核心要点。',
    category: 'shishang-chuanda',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20in%20a%20tailored%20beige%20blazer%20and%20cream%20silk%20blouse%2C%20confident%20professional%20portrait%2C%20soft%20natural%20lighting%2C%20minimalist%20office%20background%2C%20sophisticated%20fashion%20editorial%2C%20warm%20neutral%20tones%2C%20timeless%20style&width=1200&height=800&seq=article-01&orientation=landscape',
    author: '林婉清',
    date: '2026-08-10',
    readTime: '8分钟',
    tags: ['职场穿搭', '春秋搭配', '熟女时尚'],
    content: `
      <p>对于30岁以上的职场女性来说，穿搭不再仅仅是追随潮流，更重要的是展现自己的专业素养与个人品味。春秋季节的气温变化为穿搭提供了丰富的层次感可能，这正是展现熟女魅力的最佳时节。</p>
      
      <h2>面料选择：质感决定一切</h2>
      <p>成熟女性的衣橱应当以优质面料为核心。真丝、羊毛、羊绒、高品质棉麻等天然面料不仅穿着舒适，更能通过材质本身的光泽感和垂坠感提升整体造型的高级感。一件真丝衬衫搭配羊毛西裤，简约而不简单，这正是熟女穿搭的精髓所在。</p>
      <p>在春季，可以选择轻薄的羊绒开衫作为外搭，内搭真丝吊带或高支棉衬衫，既保暖又不失优雅。秋季则可以尝试羊毛混纺的西装外套，搭配丝质内搭，营造出干练而知性的职场形象。</p>
      
      <h2>配色方案：低饱和度的高级感</h2>
      <p>熟女在配色上应避免过于鲜艳跳跃的色彩，转而选择低饱和度的莫兰迪色系或大地色系。驼色、燕麦色、烟灰粉、雾霾蓝、豆沙绿等都是非常适合成熟女性的颜色，这些色彩不仅能衬托肤色，还能传达出温婉知性的气质。</p>
      <p>建议采用"70%基础色 + 25%辅助色 + 5%点缀色"的配色法则。基础色以米白、浅灰、驼色为主，辅助色可以选择当季流行但不过于张扬的色彩，点缀色则通过丝巾、手袋或首饰来体现。</p>
      
      <h2>廓形设计：合身而不紧身</h2>
      <p>熟女的服装廓形应注重"合身"而非"紧身"。略微宽松的剪裁不仅更加舒适，也能巧妙修饰身材。高腰直筒裤、A字半身裙、落肩设计的衬衫都是非常适合熟女的单品。</p>
      <p>特别推荐西装马甲搭配阔腿裤的组合，这种穿搭既能修饰腰线，又能展现出从容自信的职场态度。搭配一双尖头低跟鞋，整体造型干练而不失女性魅力。</p>
      
      <h2>配饰点缀：细节彰显品味</h2>
      <p>精致的配饰是熟女穿搭的点睛之笔。一条质感上乘的丝巾、一对简约的珍珠耳环、一块经典款腕表，都能在不经意间提升整体穿搭的精致度。配饰的选择应遵循"少即是多"的原则，一到两件精致的配饰足矣。</p>
      
      <h2>总结</h2>
      <p>熟女的春秋职场穿搭，核心在于通过优质面料、柔和配色、合身剪裁和精致配饰，打造出一个既专业又充满女性魅力的形象。记住，真正的时尚不在于追逐潮流，而在于找到最适合自己的风格，并自信地展现出来。</p>
    `,
  },
  {
    id: 2,
    slug: '35sui-hou-kangshuailao-hufu-fangan',
    title: '35岁后抗衰老护肤方案：从基础到进阶的完整攻略',
    excerpt: '年龄增长带来的肌肤变化如何应对？本文从清洁、保湿、防晒到精华选择，为你打造科学的熟女护肤体系。',
    category: 'hufu-baoyang',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20skincare%20routine%20scene%20with%20luxurious%20serums%20and%20creams%20on%20a%20clean%20marble%20vanity%2C%20soft%20warm%20lighting%2C%20rose%20gold%20accents%2C%20fresh%20rose%20petals%2C%20sophisticated%20beauty%20photography%2C%20minimalist%20aesthetic&width=1200&height=800&seq=article-02&orientation=landscape',
    author: '苏芮',
    date: '2026-08-08',
    readTime: '10分钟',
    tags: ['抗衰老', '护肤方案', '熟女保养'],
    content: `
      <p>35岁是女性肌肤的一个重要转折点。胶原蛋白开始加速流失，肌肤的自我修复能力逐渐下降，细纹、松弛、色斑等问题开始显现。然而，科学的护肤方案可以有效延缓这些衰老迹象，让熟女的肌肤依然保持光泽与弹性。</p>
      
      <h2>基础护肤三步曲：清洁、保湿、防晒</h2>
      <p>无论年龄几何，护肤的基础永远是清洁、保湿和防晒这三步。对于熟女而言，这三步的执行需要更加精细。</p>
      <p>清洁方面，建议使用氨基酸类温和洁面产品，避免过度清洁导致皮脂膜受损。早晚各清洁一次即可，早晨如果肌肤不油腻，甚至可以只用清水洗脸。</p>
      <p>保湿是熟女护肤的重中之重。随着年龄增长，肌肤的锁水能力下降，需要选择含有神经酰胺、透明质酸、角鲨烷等成分的保湿产品。建议采用"水-精华-乳液-面霜"的层叠保湿法。</p>
      <p>防晒是抗衰老最有效也最经济的方式。无论阴晴雨雪，每天都要涂抹足量的防晒霜，SPF30以上、PA+++起步，并注意每2-3小时补涂。</p>
      
      <h2>进阶抗衰老成分解析</h2>
      <p>在基础护肤之上，熟女可以针对性地引入以下抗衰老成分：</p>
      <p><strong>视黄醇（Retinol）：</strong>目前公认最有效的抗衰老成分之一，能促进胶原蛋白生成、加速细胞更新。建议从低浓度开始建立耐受，每周2-3次逐步增加到每晚使用。</p>
      <p><strong>维生素C：</strong>强效抗氧化剂，能提亮肤色、淡化色斑、促进胶原蛋白合成。建议晨间使用，搭配防晒霜效果更佳。</p>
      <p><strong>胜肽（Peptide）：</strong>通过信号传导促进胶原蛋白和弹性蛋白的生成，温和不刺激，适合与视黄醇交替使用。</p>
      <p><strong>烟酰胺（Niacinamide）：</strong>多功能成分，能改善毛孔粗大、淡化色斑、增强肌肤屏障。适合早晚使用。</p>
      
      <h2>季节护肤方案</h2>
      <p>春夏季节以清爽保湿为主，选择轻薄的乳液质地，加强防晒和抗氧化。秋冬季节则需要更加滋润的护理，使用含有油脂成分的面霜来锁住水分，同时可以增加使用护肤油的频率。</p>
      
      <h2>生活方式与肌肤健康</h2>
      <p>再好的护肤品也无法替代健康的生活方式。保证充足的睡眠、均衡的饮食、适量的运动和良好的心态，才是保持肌肤年轻的根本之道。每天饮用足够的水分，多摄入富含抗氧化物的食物如蓝莓、番茄、绿茶等，远离烟酒和高糖食品。</p>
      
      <h2>总结</h2>
      <p>熟女的护肤不需要过度复杂，关键在于坚持基础护理，科学选择有效成分，并配合健康的生活方式。记住，护肤是一场马拉松而非短跑，持之以恒才能看到最好的效果。</p>
    `,
  },
  {
    id: 3,
    slug: 'shunv-jiaju-buzhi-meixue',
    title: '熟女的居家美学：打造温暖而有格调的生活空间',
    excerpt: '家是熟女魅力的延伸。从色彩搭配到软装选择，教你如何打造一个既舒适又彰显品味的居家环境。',
    category: 'shenghuo-meixue',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20elegant%20living%20room%20interior%20with%20neutral%20warm%20tones%2C%20cozy%20throw%20blankets%2C%20fresh%20flowers%20in%20ceramic%20vase%2C%20soft%20natural%20light%2C%20sophisticated%20home%20decor%2C%20minimalist%20yet%20warm%20aesthetic%2C%20coffee%20table%20books%2C%20scented%20candle&width=1200&height=800&seq=article-03&orientation=landscape',
    author: '林婉清',
    date: '2026-08-05',
    readTime: '7分钟',
    tags: ['居家美学', '家居布置', '熟女生活'],
    content: `
      <p>家，是每个熟女展现生活品味的最佳舞台。一个布置得当的家不仅能让人身心放松，更能传递出主人的审美情趣和生活态度。熟女的居家美学，核心在于温暖、舒适与格调的完美统一。</p>
      
      <h2>色彩基调：宁静而温暖的底色</h2>
      <p>熟女的家居色彩应以温暖的中性色为基调。米白、燕麦色、浅灰褐、奶油色等低饱和度的色彩能够营造出宁静舒适的氛围。在这个基础上，可以通过抱枕、地毯、挂画等软装饰品添加一些柔和的色彩点缀，如鼠尾草绿、烟熏玫瑰色等。</p>
      <p>避免使用过于冷峻的纯白色或灰色，也不要选择过于鲜艳跳跃的色彩。熟女的居家空间应当是温暖的、包容的，如同一个温柔的拥抱。</p>
      
      <h2>材质搭配：触感的层次美</h2>
      <p>居家空间的质感很大程度上取决于材质的搭配。棉麻的沙发套、羊毛的地毯、丝绒的抱枕、藤编的收纳篮，不同材质的组合能够创造出丰富的触感层次。特别是在秋冬季节，毛绒绒的毯子和厚实的地毯能够瞬间提升空间的温暖感。</p>
      
      <h2>灯光设计：氛围的灵魂</h2>
      <p>灯光是营造居家氛围的关键元素。熟女的家中应避免使用单一的主灯照明，而是采用多层次的灯光设计。落地灯、台灯、壁灯和香薰蜡烛的组合，能够在不同的时间和场景下创造出不同的氛围。暖色调的灯光（2700K-3000K）是最佳选择，能让整个空间显得更加温馨柔和。</p>
      
      <h2>绿植与花艺：生命的点缀</h2>
      <p>一盆郁郁葱葱的绿植或一束精心挑选的鲜花，能为居家空间注入生命力。对于不擅长养护植物的熟女，可以选择龟背竹、琴叶榕、虎皮兰等容易养护的绿植。每周更换一束当季鲜花，让家始终充满生机与美好。</p>
      
      <h2>收纳的艺术</h2>
      <p>一个整洁有序的家是熟女生活品质的体现。善用藤编篮、布艺收纳盒、陶瓷罐等兼具美观与实用的收纳工具，将杂物巧妙地隐藏起来。遵循"物归原位"的原则，让每一个物品都有属于自己的位置。</p>
      
      <h2>总结</h2>
      <p>熟女的居家美学不在于奢华昂贵的家具，而在于用心营造的温暖氛围和处处流露的品味细节。让家成为一个可以完全放松、滋养身心的港湾，这才是居家美学的真谛。</p>
    `,
  },
  {
    id: 4,
    slug: '40sui-nvxing-ziwo-tisheng-zhilu',
    title: '40岁女性的自我提升之路：在成熟中遇见更好的自己',
    excerpt: '40岁不是终点而是新的起点。从心理建设到技能学习，探讨熟女如何在人生的黄金阶段实现自我突破。',
    category: 'ziwo-chengzhang',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20sitting%20by%20a%20large%20window%20with%20a%20journal%20and%20cup%20of%20tea%2C%20peaceful%20morning%20light%2C%20serene%20contemplative%20atmosphere%2C%20warm%20neutral%20interior%2C%20sophisticated%20lifestyle%20photography%2C%20soft%20focus&width=1200&height=800&seq=article-04&orientation=landscape',
    author: '陈雅文',
    date: '2026-08-02',
    readTime: '9分钟',
    tags: ['自我提升', '女性成长', '熟女人生'],
    content: `
      <p>40岁，对于许多女性来说是一个充满智慧与魅力的年龄。经历了青春的懵懂和中年的奋斗，此时的女性拥有丰富的阅历和稳定的心态，正是开启人生新篇章的最佳时机。自我提升不再是为了取悦他人，而是为了遇见更好的自己。</p>
      
      <h2>心态重塑：接纳与成长</h2>
      <p>熟女自我提升的第一步，是学会全然接纳自己。接纳年龄带来的变化，接纳不完美的自己，然后在此基础上寻求成长。比较是快乐的小偷，不必拿自己和20岁的女孩相比，每个年龄段都有其独特的美。</p>
      <p>建议每天留出15-20分钟进行冥想或写感恩日记，培养积极的心态。研究表明，感恩练习能够显著提升幸福感和生活满意度。</p>
      
      <h2>终身学习：知识是最好的投资</h2>
      <p>在这个快速变化的时代，终身学习已经成为一种必需。对于熟女来说，学习不仅能够保持思维的活跃，更能够打开新的职业或兴趣的可能性。可以选择在线课程学习一门新语言、报名参加感兴趣的工作坊、或者系统地阅读某个领域的经典著作。</p>
      <p>特别推荐熟女尝试艺术类学习，如绘画、陶艺、花艺或书法，这些活动不仅能够陶冶情操，还能在创作中获得心流体验和成就感。</p>
      
      <h2>身体健康：活力的源泉</h2>
      <p>充沛的精力是自我提升的基础。40岁后的女性应更加重视身体的管理。推荐瑜伽和普拉提作为主要运动方式，它们不仅能塑形，还能改善体态、缓解压力。每周保持3-4次、每次40-60分钟的运动习惯。</p>
      <p>饮食方面，增加优质蛋白的摄入，减少精制碳水和糖分，多食用深色蔬菜和富含omega-3的食物如三文鱼、核桃等。</p>
      
      <h2>社交圈层：高质量的人际关系</h2>
      <p>熟女的社交应当追求质量而非数量。与积极向上、志同道合的朋友保持联系，参加读书会、品茶会、手作工坊等有品质的社交活动。远离消耗能量的关系，珍惜那些能让你感到被理解、被支持的友谊。</p>
      
      <h2>总结</h2>
      <p>40岁不是下坡路的开始，而是登顶后看到更广阔风景的时刻。通过心态调整、持续学习、身体管理和优质社交，每一位熟女都能在成熟中遇见更好的自己，活出更加精彩的人生下半场。</p>
    `,
  },
  {
    id: 5,
    slug: 'shunv-dongji-dapei-xinde',
    title: '熟女冬季穿搭心得：保暖与时尚可以兼得',
    excerpt: '冬季穿搭如何在保暖的同时不失优雅？从大衣选择到内搭技巧，分享熟女冬季穿搭的实用心得。',
    category: 'shishang-chuanda',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20in%20a%20long%20camel%20wool%20coat%20walking%20through%20a%20city%20street%20on%20a%20winter%20day%2C%20soft%20warm%20lighting%2C%20sophisticated%20winter%20fashion%2C%20neutral%20tones%2C%20cashmere%20scarf%2C%20leather%20gloves%2C%20confident%20elegant%20style&width=1200&height=800&seq=article-05&orientation=landscape',
    author: '林婉清',
    date: '2026-07-28',
    readTime: '6分钟',
    tags: ['冬季穿搭', '大衣搭配', '熟女时尚'],
    content: `
      <p>冬季对于熟女来说是一个展现穿搭功力的好季节。层次丰富的冬季穿搭既考验搭配技巧，也为展现个人风格提供了更多可能。只要掌握几个核心要点，保暖与时尚完全可以兼得。</p>
      
      <h2>大衣是冬季穿搭的灵魂</h2>
      <p>一件版型优良的大衣能够瞬间提升整体造型的质感。熟女在选择大衣时，建议投资经典款式而非追逐潮流。驼色、黑色、深灰、燕麦色的羊毛大衣是最不易出错的选择。长度方面，及膝或过膝的中长款最能展现优雅气质。</p>
      <p>双面呢大衣因其轻盈保暖的特性，是熟女冬季的绝佳选择。搭配一条质感上乘的羊绒围巾，既能增加层次感，又能在寒冷的日子里提供额外的温暖。</p>
      
      <h2>内搭的智慧</h2>
      <p>冬季穿搭的秘诀在于层次感。高领羊绒衫是熟女冬季衣橱的必备单品，既保暖又显气质。在羊绒衫外可以叠加一件真丝衬衫或薄款针织开衫，创造出丰富的层次效果。</p>
      <p>下装方面，羊毛阔腿裤或直筒裤是最舒适也最优雅的选择。深色系的裤子搭配浅色系的上衣和内搭，能够创造出显高显瘦的视觉效果。</p>
      
      <h2>冬季配饰的点睛之笔</h2>
      <p>冬季配饰不仅具有实用功能，也是展现个人品味的重要元素。一条质感上乘的羊绒围巾、一双精致的皮手套、一顶简约的贝雷帽，都能让整体造型更加完整。</p>
      <p>靴子是冬季穿搭的重要组成部分。及踝短靴搭配九分裤或裙子，过膝长靴搭配短裙或紧身裤，都是非常经典的熟女冬季搭配方式。</p>
      
      <h2>总结</h2>
      <p>熟女的冬季穿搭不需要盲目追随潮流，关键在于选择高品质的基础单品，通过巧妙的层次搭配和精致的配饰点缀，打造出既保暖又优雅的冬季造型。记住，真正的时尚是舒适而自信的。</p>
    `,
  },
  {
    id: 6,
    slug: 'shunv-meirong-yinshi-yangsheng',
    title: '由内而外的美丽：熟女美容饮食与养生指南',
    excerpt: '美丽的肌肤源于内在的滋养。从抗氧化的超级食物到日常养生茶饮，分享熟女的饮食养生智慧。',
    category: 'hufu-baoyang',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20arrangement%20of%20fresh%20fruits%20berries%20nuts%20and%20herbal%20tea%20on%20a%20wooden%20table%2C%20warm%20natural%20light%2C%20healthy%20lifestyle%20photography%2C%20elegant%20food%20styling%2C%20soft%20cream%20background%2C%20sophisticated%20wellness%20aesthetic&width=1200&height=800&seq=article-06&orientation=landscape',
    author: '苏芮',
    date: '2026-07-25',
    readTime: '8分钟',
    tags: ['美容饮食', '养生', '熟女保养'],
    content: `
      <p>真正美丽的肌肤，源于由内而外的滋养。再昂贵的护肤品也只能作用于肌肤表层，而健康的饮食和良好的生活习惯，才能从根本上改善肌肤状态，让熟女魅力从内而外地散发出来。</p>
      
      <h2>抗氧化超级食物清单</h2>
      <p>抗氧化是抗衰老的核心。以下食物富含抗氧化物质，建议熟女日常多摄入：</p>
      <p><strong>蓝莓：</strong>花青素含量极高，能有效对抗自由基，延缓肌肤老化。每天一小把蓝莓，可以作为早餐燕麦的配料或下午的健康零食。</p>
      <p><strong>番茄：</strong>富含番茄红素，烹饪后吸收率更高。番茄红素能保护肌肤免受紫外线伤害。</p>
      <p><strong>坚果：</strong>核桃、杏仁、巴西坚果富含维生素E和健康脂肪，能维持肌肤的弹性和光泽。每天一小把（约30克）即可。</p>
      <p><strong>深绿色蔬菜：</strong>菠菜、羽衣甘蓝等富含叶绿素和多种维生素，有助于排毒养颜。</p>
      
      <h2>养生茶饮推荐</h2>
      <p>熟女的日常饮品选择对肌肤和健康有着重要影响。推荐以下养生茶饮：</p>
      <p><strong>玫瑰花茶：</strong>疏肝解郁、调经养颜，是熟女日常保养的理想饮品。每天一杯玫瑰花茶，不仅能美容养颜，还能舒缓情绪。</p>
      <p><strong>枸杞红枣茶：</strong>补气血、养肝肾。对于经常熬夜或工作压力大的熟女来说，这款茶饮能够帮助恢复元气。</p>
      <p><strong>绿茶：</strong>富含儿茶素，强效抗氧化。建议选择品质较好的绿茶，用80℃左右的热水冲泡。</p>
      
      <h2>需要警惕的"美丽杀手"</h2>
      <p>高糖食品是肌肤老化的加速器。过多的糖分会与肌肤中的胶原蛋白发生糖化反应，导致肌肤松弛、产生皱纹。建议熟女减少甜点、含糖饮料的摄入，用水果代替甜食。</p>
      <p>过量的咖啡因和酒精也会加速肌肤老化。每天咖啡不超过两杯，酒精尽量少饮或不饮。</p>
      
      <h2>总结</h2>
      <p>美丽的肌肤是良好生活习惯的奖赏。通过合理的饮食搭配、充足的睡眠和适度的运动，每一位熟女都能由内而外地焕发出健康的光彩。记住，你吃下的每一口食物，都在塑造明天的你。</p>
    `,
  },
];